var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.631,
    height: 20.631,
    viewBox: "0 0 20.631 20.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-497.786 -232.935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.786,232.935h20.631v20.631H497.786Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.786,232.935h20.631v20.631H497.786Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.259,239.678l-6.849,3.337-.361-.743,6.849-3.337Zm-.372,9.942-6.624-3.346.372-.737,6.624,3.345Z",
    transform: "translate(-1.444 -1.049)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.4,234.935a2.888,2.888,0,1,1-2.888,2.888A2.888,2.888,0,0,1,514.4,234.935Zm0,11.553a2.888,2.888,0,1,1-2.888,2.888A2.888,2.888,0,0,1,514.4,246.488Zm-10.728-5.777a2.888,2.888,0,1,1-2.888,2.888A2.888,2.888,0,0,1,503.674,240.712ZM514.4,235.76a2.063,2.063,0,1,0,2.063,2.063A2.063,2.063,0,0,0,514.4,235.76Zm0,11.553a2.063,2.063,0,1,0,2.063,2.063A2.063,2.063,0,0,0,514.4,247.313Zm-10.728-5.777a2.063,2.063,0,1,0,2.063,2.063A2.063,2.063,0,0,0,503.674,241.537Z",
    transform: "translate(-0.524 -0.35)",
    fill: "#0c4767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3ab7b587ae2c623b126a3f6ba2b76ef8.svg";
export { ForwardRef as ReactComponent };